export type StorePaidPlan = 'plus' | 'pro' | 'studio'
export type StoreBillingPeriod = 'monthly' | 'yearly'

export const PRODUCT_IDS = {
  proMonthly: 'voxnela_pro',
  proYearly: 'voxnela_pro_year',
  studioMonthly: 'voxnela_studio',
  studioYearly: 'voxnela_studio_year',
} as const

export function productIdForOffer(
  plan: StorePaidPlan,
  period: StoreBillingPeriod,
): string {
  // Plus is kept only as a read-only alias for older entitlements.
  const publicPlan = plan === 'plus' ? 'pro' : plan
  if (publicPlan === 'studio') {
    return period === 'yearly' ? PRODUCT_IDS.studioYearly : PRODUCT_IDS.studioMonthly
  }
  return period === 'yearly' ? PRODUCT_IDS.proYearly : PRODUCT_IDS.proMonthly
}
